import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ToastrModule } from "ngx-toastr";

import { AppRoutingModule } from "./app-routing.module";
import { AuthModule } from "./auth/auth.module";
import { PractitionerModule } from "./practitioner/practitioner.module";
import { UnsubscribeModule } from "./unsubscribe/unsubscribe.module";
import { DirectLinkModule } from "./directlink/directlink.module";
import { NavModule } from "./nav/nav.module";
import { DirectoryModule } from "./directory/directory.module";
import { HorizonsModule } from "./horizons/horizons.module";
import { LicensureModule } from "./licensure/licensure.module";
import { PurchaseModule } from "./purchase/purchase.module";
import { VoucherPurchaseModule } from "./voucher/voucher.module";
import { MessageCenterModule } from "./message-center/message-center.module";
import { PipesModule } from "./shared/pipes/pipes.module";

import { AppSettingsService } from "./shared/services/app-settings.service";

import { AuthMocksService } from "./shared/services/mocks/auth-mocks.service";

import { PortalApiService } from "./shared/services/api/portal-api.service";
import { CommonApiService } from "./shared/services/api/common-api.service";
import { UserService } from "./shared/services/user.service";
import { ViewStateService } from "./shared/services/view-state.service";
import { NotificationsService } from "./shared/services/notifications.service";
import { PurchaseStateService } from "./purchase/shared/services/purchase-state.service";

import { AppComponent } from "./app.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { SearchBarComponent } from "./search-bar/search-bar.component";
import { LoadingSpinnerComponent } from "./shared/components/loading-spinner/loading-spinner.component";
import { AssessmentModule } from "./assessment/assessment.module";

import { LiveChatWidgetModule } from '@livechat/widget-angular';
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { CookieService } from "ngx-cookie-service";
import { HttpClientModule } from "@angular/common/http";
import { MomentModule } from 'ngx-moment';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    NotFoundComponent,
    SearchBarComponent,
    LoadingSpinnerComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      timeOut: 5000,
      closeButton: true,
      progressBar: true,
      maxOpened: 1,
      autoDismiss: true,
    }),
    AuthModule,
    PractitionerModule,
    UnsubscribeModule,
    DirectLinkModule,
    NavModule,
    DirectoryModule,
    HorizonsModule,
    LicensureModule,
    PurchaseModule,
    VoucherPurchaseModule,
    AssessmentModule,
    MessageCenterModule,
    PipesModule,
    HttpClientModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaskDirective,
    MomentModule,
    LiveChatWidgetModule
  ],
  providers: [
    AppSettingsService,    
    AuthMocksService,    
    PortalApiService,
    UserService,
    ViewStateService,
    CommonApiService,
    NotificationsService,
    PurchaseStateService,
    CookieService,
    provideNgxMask()
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
